import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { useQueryClient } from "@tanstack/react-query";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { deleteTeam } from "../hooks/useTeam";
import { Transition } from "../utils/common";

interface DialogDeleteTeamProps {
  id?: string;
  isOpen: boolean;
  onIsOpenChange: (isOpen: boolean) => void;
  navigateOnDelete?: string;
}
const DialogDeleteTeam: React.FC<DialogDeleteTeamProps> = ({
  id,
  isOpen,
  onIsOpenChange,
  navigateOnDelete,
}) => {
  const navigate = useNavigate();

  const queryClient = useQueryClient();
  const [showDeleteDialog, setShowDeleteDialog] =
    React.useState<boolean>(false);

  React.useEffect(() => {
    setShowDeleteDialog(isOpen);
  }, [isOpen]);

  React.useEffect(() => {
    onIsOpenChange(showDeleteDialog);
  }, [showDeleteDialog]);
  return (
    <Dialog
      open={showDeleteDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => {
        setShowDeleteDialog(false);
      }}
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        sx: { backgroundColor: "#fff", minWidth: "400px" },
      }}
    >
      <DialogTitle>{" Are you sure you want to delete this team?"}</DialogTitle>

      <DialogActions
        sx={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          alignContent: "center",
          width: "100%",
        }}
      >
        <Button
          size="small"
          color="error"
          variant="outlined"
          onClick={async () => {
            if (id) {
              await deleteTeam(id);
              setShowDeleteDialog(false);
              await queryClient.refetchQueries({ queryKey: ["teams"] });
              if (navigateOnDelete) {
                navigate(navigateOnDelete);
              }
            }
          }}
        >
          yes
        </Button>
        <Button
          color="secondary"
          variant="outlined"
          size="small"
          onClick={() => {
            setShowDeleteDialog(false);
          }}
        >
          no
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogDeleteTeam;
